// extracted by mini-css-extract-plugin
export default {"wrapper":"label_wrapper__-xDdQ","name":"label_name__tWp-w","value":"label_value__PBXuZ"};